<template>
<div class="comPreviews fix" style="display:flex;justify-content:space-between;" v-if="resultList">
    <template v-if="!resultList.length">
        <div class="conLeft fl w780">
            <div class="borderLine borderTop title color333 noMes">
                下届拍卖预展正在筹备中，敬请期待！</div>
            <div class="mt30">
                <transBoutique :title="'成交精品欣赏'" :list="transBoutiqueList"></transBoutique>
            </div>
            <div class="goodRank mt25">
                <div class="goodTitleBox">
                    <span class="goodTitle auctionFont">成交拍品榜</span>
                </div>
                <ul class="flex goodRankUl">
                    <goodRank v-for="(item, i) in rankTitleList"
                            :title="'成交价'" 
                            :key="item.id" 
                            :rankTitle="item.title" 
                            :list="goodRankList[i]"  
                    ></goodRank>
                </ul>
            </div>
        </div>
    </template>
    <template v-else>
        <page-have :resultList="resultList" :swiperList="swiperList" :pages="pages" @clickPagination="$emit('clickPagination', $event)"/>
    </template>
    <div class="conRight padRight fr w380 borderLine" style="height:580px;">
        <div class="comInfo">
            <div class="comTitle comTitleLine">
                <span class="auctionFont conTitle">公司信息</span>
            </div>
            <companyInfo :list="companyInfoList"></companyInfo>
        </div>
        <div class="comInfo">
            <span class="auctionFont conTitle mtb17">用户服务</span>
            <service :list="serviceList"></service>
        </div>
    </div>
</div>
</template>

<script>
// import companyInfo from "../components/companyInfo";
import companyInfo from "@/views/auctionCompany/components/companyInfo";
import service from "@/views/auctionCompany/components/service";
import goodRank from "@/views/auctionCompany//components/goodRank";
import transBoutique from "@/views/auctionCompany//components/previews/transBoutique";
import { postDetail, postResult } from '@/api/company'
import pageHave from './have'
export default {
    name: "previews",
    props: ['resultList', "swiperList", 'pages'],
    data(){
        return{
            rankTitleList:[
                {id:1,title:"历史成交排行榜"},
                {id:2,title:"最近成交排行榜"},
            ],
            aucPreviewList:[
                {},
            ],
            auctionGoodList:[
                {},
            ],
            companyInfoList: {},
            serviceList: {},
            goodRankList: [],
            transBoutiqueList: [],
        }
    },
    mounted() {
        const webName = this.$router.history.current.params.name;
        this.postDetail(webName);
    },
    methods: {
        postDetail(name) {
            postDetail({
                web_name: name
            }).then(res => {
                this.postResult(res.data.organ_id)
                // 公司信息
                this.companyInfoList = {
                    organ_name: res.data.organ_name,
                    regiter_time: res.data.regiter_time,
                    auth_num: res.data.auth_num,
                    good_business: res.data.good_business,
                    core_business: res.data.core_business,
                    area: res.data.area,
                    art_num: res.data.art_num,
                    total_price: res.data.total_price,
                    miroblog_pic: res.data.miroblog_pic,

                }
                // 用户服务
                this.serviceList = {
                    service: res.data.service
                }
            })
        },
        postResult(id) {
            postResult({
                organCode: id
            }).then(res => {
                // 成交精品欣赏
                this.transBoutiqueList = res.data.goos_result
                // 历史成交排行榜
                this.goodRankList[0] = res.data.history_result_auction
                // 最近成交排行榜
                this.goodRankList[1] = res.data.current_result_auction
            })
        }
    },
    components:{
        companyInfo,
        service,
        goodRank,
        transBoutique,
        pageHave
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/css/auctionCompany.scss";
.comPreviews{
    .noMes{
        border-left: 1px solid #e6e6e6;
        border-right: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        height: 208px;
        line-height: 208px;
        text-align: center;
        font-size: 18px;
    }
}
</style>